import {
  trackLandingLeadConversion,
  trackProductEvent,
  type AnalyticsProperties,
} from '@/lib/analytics';
import { sendServerEvent } from '@/lib/attribution';

const LINKEDIN_BOOK_DEMO_CONVERSION_ID = '28067788';

// Landing page (public marketing site) tracking helpers.
// CTA button clicks are captured via the generic click handler using
// data-analytics-event="Landing CTA Clicked" attributes on the buttons, so the
// only explicit call needed here is the successful contact-form submission.
export const trackLandingContactSubmitted = (properties: AnalyticsProperties = {}) => {
  const payload = {
    product_area: 'landing',
    landing_section: 'ready_to_grow_practice',
    ...properties,
  };

  trackProductEvent('Landing Contact Form Submitted', payload);
  trackLandingLeadConversion(payload);
};

export const trackLinkedInBookDemoSubmitted = (properties: AnalyticsProperties = {}) => {
  sendServerEvent('Book Demo Form Submitted', {
    product_area: 'landing',
    landing_section: 'ready_to_grow_practice',
    lead_intent: 'book_demo',
    vendor: 'linkedin',
    conversion_id: LINKEDIN_BOOK_DEMO_CONVERSION_ID,
    linkedin_conversion_id: LINKEDIN_BOOK_DEMO_CONVERSION_ID,
    ...properties,
  });
};
